import { createURL } from './url-helpers';

export interface IEnvService {
  FORMS_API_URL: string;
  AGENDA_API_URL: string;
  ISSUANCE_API_URL: string;
  APP_USER_API_URL: string;
  ACCREDITATION_API_URL: string;
  APP_HUB_API_URL: string;
  APP_BG_IMAGE_URL: string;
}

export class EnvService implements IEnvService {
  private static instance: EnvService | null = null;

  AGENDA_API_URL: string;

  ISSUANCE_API_URL: string;

  FORMS_API_URL: string;

  APP_USER_API_URL: string;

  ACCREDITATION_API_URL: string;

  APP_HUB_API_URL: string;

  APP_BG_IMAGE_URL: string;

  static getInstance(): EnvService {
    if (!this.instance) {
      this.instance = new EnvService();
    }
    return this.instance;
  }

  private constructor() {
    this.loadEnvVariables();
  }

  private loadEnvVariables(): void {
    // Read environment variables from browser window
    const browserWindowEnv = (window as any)?.__env ?? {};

    // properties that needs to be checked whether contain the full URL
    // or just the path like /api/issuance
    const URL_PROPERTIES: string[] = [
      'AGENDA_API_URL',
      'ISSUANCE_API_URL',
      'FORMS_API_URL',
      'APP_USER_API_URL',
      'ACCREDITATION_API_URL',
      'APP_HUB_API_URL',
      'APP_BG_IMAGE_URL',
    ];

    // Assign environment variables from browser window to env
    // In the current implementation, properties from env.js overwrite defaults from the EnvService.
    // If needed, a deep merge can be performed here to merge properties instead of overwriting them.
    Object.keys(browserWindowEnv).forEach((key) => {
      // eslint-disable-next-line
      if (browserWindowEnv.hasOwnProperty(key)) {
        const envVariableValue = browserWindowEnv[key];

        if (envVariableValue && URL_PROPERTIES.includes(key)) {
          // @ts-ignore
          this[key] = createURL(browserWindowEnv[key]).toString();
        } else {
          // @ts-ignore
          this[key] = envVariableValue;
        }
      }
    });
  }
}
